import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { RootState } from '../../../../store/root-reducer';
import TasksContent from './tasks-content';
import {
  GetTaskerParams,
  GetTasksParams,
  UpdateTask,
  UpdateTaskNoteRequest,
} from '../../utils/types';
import {
  bulkTasksUpdateRequest,
  getTaskerDataRequest,
  getTasksRequest,
  getTaskStatusCountRequest,
  getUndoTasksRequest,
  updateTaskNoteRequest,
  updateTasksRequest,
  getFailedTasksRequest,
} from '../../extra-actions';
import { retryLinkedInTasksRequest } from '../../../linkedin-automation/extra-actions';
import { TaskStatusKey } from '../../utils/enums';
import {
  ProspectFilters,
  AddTagsToProspectsPayload,
  markAsRepliedParam,
  removeFromSequenceParam,
} from '../../../prospect/types';
import {
  checkAll,
  checkSingle,
  removeTaskFromTaskerData,
  resetSelectedTasks,
  resetTasksFilters,
  setTasksFilters,
  onBulkSelectTasks,
  clearTasksSelection,
  resetBulkTasksState,
  resetUndoTasksState,
  resetGetTasksState,
} from '../../tasks-slice';
import { getCustomOutcomeRequest } from '../../../settings/components/custom-outcomes/extra-actions';
import { onOutcomeChangeRequest } from '../../../sequence/extra-actions';
import {
  unsubscribeProspectRequest,
  addToStepRequest,
  removeProspectRequest,
  getSingleProspectSequencesDetailsRequest,
  singleProspectSequencesMarkAsRepliedRequest,
  singleProspectRemoveFromSequencesRequest,
  saveContactAttributesRequest,
  getSingleProspectDetailsRequest,
  singleProspectSequencesMarkAsFinishedRequest,
  changePrimaryEmailInProspectRequest,
  deleteSecondaryEmailRequest,
  deleteSecondaryPhoneRequest,
  getTagsRequest,
  addTagsToProspectsRequest,
  getSequenceListRequest,
  getStepListRequest,
  getFieldsRequest,
} from '../../../prospect/extra-actions';
import {
  resetProspectDeleteEmailRequestStatus,
  resetProspectDeletePhoneRequestStatus,
  resetRemoveProspectRequest,
  resetSaveContactAttributesRequestStatus,
  resetSequenceAndStepData,
  resetProspectPrimaryEmailChangeRequestStatus,
  resetTags,
} from '../../../prospect/prospect-slice';
import {
  setSelectedProspectId,
  resetSelectedProspectId,
  resetSelectedProspectData,
} from '../../../sequence/sequence-slice';

const mapStateToProps = (state: RootState) => ({
  isDemoAccount: state.home.isDemoAccount,
  tasks: state.tasks.tasks,
  tasksCount: state.tasks.tasksCount,
  getTasksRequestStatus: state.tasks.getTasksRequest.status,
  taskActionRequestStatus: state.tasks.updateTasksRequest.status,
  bulkTasksUpdateRequestStatus: state.tasks.bulkTasksUpdateRequest.status,
  bulkTasksUpdateRequestMessage: state.tasks.bulkTasksUpdateRequest.message,
  getUndoTasksRequestStatus: state.tasks.getUndoTasksRequest.status,
  updateTaskRequestMessage: state.tasks.updateTasksRequest.message,
  tasksFilters: state.tasks.tasksFilters,
  selectedTasks: state.tasks.selectedTasks,
  updateTaskNoteRequestStatus: state.tasks.updateTaskNoteRequest.status,
  outcomeChangeRequestStatus: state.sequence.onOutcomeChangeRequest.status,
  allOutcomes: state.customOutcome.outcomes,
  bulkSelectedTasks: state.tasks.bulkSelectedTasks,
  taskStatusCount: state?.tasks?.taskStatusCount,
  isFirstTimeUser: state?.tasks?.isFirstTimeUser,
  localTaskStatusCount: state?.tasks?.taskStatusCount,
  failedTasks: state.tasks.failedTasks,
  failedTasksCount: state.tasks.failedTasksCount,

  // Prospect Details Props
  addToStepRequestStatus: state.prospect.addToStepRequest.status,
  addToStepRequestError: state.prospect.addToStepRequest.error,
  addToStepRequestMessage: state.prospect.addToStepRequest.message,
  addToStepRequestFailedCount:
    state.prospect.addToStepRequestResultCount.failed,
  addToStepRequestSuccessfulCount:
    state.prospect.addToStepRequestResultCount.successful,

  removeProspectStatus: state.prospect.removeProspectRequest.status,
  removeProspectError: state.prospect.removeProspectRequest.error,
  removeProspectMessage: state.prospect.removeProspectRequest.message,

  unsubscribeProspectStatus: state.prospect.unsubscribeProspectRequest.status,
  unsubscribeProspectError: state.prospect.unsubscribeProspectRequest.error,
  unsubscribeProspectMessage: state.prospect.unsubscribeProspectRequest.message,

  markAsRepliedError:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.error,
  markAsRepliedMessage:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.message,
  markAsRepliedStatus:
    state.prospect.singleProspectSequencesMarkAsRepliedRequest.status,

  markAsFinishedError:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.error,
  markAsFinishedMessage:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.message,
  markAsFinishedStatus:
    state.prospect.singleProspectSequencesMarkAsFinishedRequest.status,

  removeFromSequenceStatus:
    state.prospect.singleProspectRemoveFromSequencesRequest.status,
  removeFromSequenceError:
    state.prospect.singleProspectRemoveFromSequencesRequest.error,
  removeFromSequenceMessage:
    state.prospect.singleProspectRemoveFromSequencesRequest.message,

  deleteSecondaryEmailRequestStatus:
    state.prospect.deleteSecondaryEmailRequest.status,
  deleteSecondaryEmailRequestError:
    state.prospect.deleteSecondaryEmailRequest.error,
  deleteSecondaryEmailRequestMessage:
    state.prospect.deleteSecondaryEmailRequest.message,

  deleteSecondaryPhoneRequestStatus:
    state.prospect.deleteSecondaryPhoneRequest.status,
  deleteSecondaryPhoneRequestError:
    state.prospect.deleteSecondaryPhoneRequest.error,
  deleteSecondaryPhoneRequestMessage:
    state.prospect.deleteSecondaryPhoneRequest.message,

  primaryEmailChangeRequestStatus:
    state.prospect.changePrimaryEmailInProspectRequest.status,
  primaryEmailChangeRequestError:
    state.prospect.changePrimaryEmailInProspectRequest.error,
  primaryEmailChangeRequestMessage:
    state.prospect.changePrimaryEmailInProspectRequest.message,

  saveContactAttributesRequestStatus:
    state.prospect.saveContactAttributesRequest.status,
  saveContactAttributesRequestError:
    state.prospect.saveContactAttributesRequest.error,
  saveContactAttributesRequestMessage:
    state.prospect.saveContactAttributesRequest.message,

  tags: state.prospect.tags,
  addTagsToProspectsRequestStatus:
    state.prospect.addTagsToProspectsRequest.status,

  // AddToSequenceModal Props
  sequenceList: state.prospect.sequences,
  getSequenceListRequestStatus: state.prospect.getSequenceListRequest.status,
  getSequenceListRequestError: state.prospect.getSequenceListRequest.error,
  stepList: state.prospect.steps,
  getStepListRequestStatus: state.prospect.getStepListRequest.status,
  getStepListRequestError: state.prospect.getStepListRequest.error,

  // Single Prospect Details Props
  selectedProspectId: state.sequence.selectedProspectId,
  selectedProspectData: state.prospect.singleProspect,
  selectedProspectSequences: state.prospect.singleProspectSequenceDetails,
  getSingleProspectDetailsStatus:
    state.prospect.getSingleProspectDetailsRequest.status,
  getSingleProspectSequencesDetailsStatus:
    state.prospect.getSingleProspectSequencesDetailsRequest.status,
  Fields: state.prospect.fields,
});

const mapDispatchToProps = {
  getTasksRequest: (params: GetTasksParams) => getTasksRequest(params),
  updateTasksRequest: (payload: UpdateTask) => updateTasksRequest(payload),
  getTasksStatusCountRequest: (params: GetTasksParams) =>
    getTaskStatusCountRequest(params),
  updateTaskNoteRequest: (payload: UpdateTaskNoteRequest) =>
    updateTaskNoteRequest(payload),
  setTasksFilters: (filters: ProspectFilters) => setTasksFilters(filters),
  resetTasksFilters: (filter: string) => resetTasksFilters(filter),
  checkSingle: ({ row, status }) => checkSingle({ row, status }),
  checkAll: ({ rows, status }) => checkAll({ rows, status }),
  resetSelectedTasks: () => resetSelectedTasks(),
  removeTaskFromTaskerData: (taskId: number) =>
    removeTaskFromTaskerData({ taskId }),
  showLoadingBar: () => showLoading(),
  hideLoadingBar: () => hideLoading(),
  sendGetAllOutcomesRequest: () => getCustomOutcomeRequest(),
  onOutcomeChangeRequest: (
    sequenceId: number,
    prospectId: number,
    outcomeId: number,
  ) => onOutcomeChangeRequest({ sequenceId, prospectId, outcomeId }),
  sendBulkTasksUpdateRequest: (payload) => bulkTasksUpdateRequest(payload),
  onBulkSelectTasks: (payload) => onBulkSelectTasks(payload),
  clearTasksSelection: () => clearTasksSelection(),
  sendGetUndoTasksRequest: (params: GetTasksParams, taskId: number) =>
    getUndoTasksRequest({ params, taskId }),
  resetBulkTasksState: () => resetBulkTasksState(),
  resetUndoTasksState: () => resetUndoTasksState(),

  // Prospect Details Dispatch Props
  sendAddContactToStepRequest: (payload) => addToStepRequest(payload),
  resetSequenceAndStepData: () => resetSequenceAndStepData(),
  sendRemoveProspectRequest: (contactArr: number[]) =>
    removeProspectRequest(contactArr),
  sendUnsubscribeProspectRequest: (contactArr: number[]) =>
    unsubscribeProspectRequest(contactArr),
  sendGetSingleProspectSequencesDetailsRequest: (contactArr: number) =>
    getSingleProspectSequencesDetailsRequest(contactArr),
  sendSequenceMarkAsRepliedRequest: (contactAndStepIds: markAsRepliedParam[]) =>
    singleProspectSequencesMarkAsRepliedRequest(contactAndStepIds),
  sendSequenceMarkAsFinishedRequest: (
    contactAndStepIds: markAsRepliedParam[],
  ) => singleProspectSequencesMarkAsFinishedRequest(contactAndStepIds),
  sendSingleProspectRemoveFromSequencesRequest: (
    param: removeFromSequenceParam,
  ) => singleProspectRemoveFromSequencesRequest(param),
  sendSaveContactAttributesRequest: (contactId: number, attributes: []) =>
    saveContactAttributesRequest({ contactId, attributes }),
  sendGetSingleProspectDetailsRequest: (contactId: number) =>
    getSingleProspectDetailsRequest(contactId),
  resetRemoveProspectRequest: () => resetRemoveProspectRequest(),
  resetSaveContactAttributesRequestStatus: () =>
    resetSaveContactAttributesRequestStatus(),
  sendPrimaryEmailChangeInProspectRequest: (
    primaryEmailProspectInfoId: number,
    contactId: number,
  ) =>
    changePrimaryEmailInProspectRequest({
      primaryEmailProspectInfoId,
      contactId,
    }),
  sendDeleteEmailFromProspectRequest: (
    prospectInfoId: number,
    contactId: number,
  ) => deleteSecondaryEmailRequest({ prospectInfoId, contactId }),
  sendDeletePhoneFromProspectRequest: (
    prospectInfoId: number,
    contactId: number,
  ) => deleteSecondaryPhoneRequest({ prospectInfoId, contactId }),
  resetProspectDeleteEmailRequestStatus: () =>
    resetProspectDeleteEmailRequestStatus(),
  resetProspectDeletePhoneRequestStatus: () =>
    resetProspectDeletePhoneRequestStatus(),
  resetProspectPrimaryEmailChangeRequestStatus: () =>
    resetProspectPrimaryEmailChangeRequestStatus(),
  sendGetTagsRequest: () => getTagsRequest(),
  sendAddTagsToProspectsRequest: (payload: AddTagsToProspectsPayload) =>
    addTagsToProspectsRequest(payload),
  resetTags: () => resetTags(),

  // AddToSequenceModal Dispatch Props
  sendGetSequenceList: () => getSequenceListRequest(),
  sendGetSequenceStepList: (sequenceId) => getStepListRequest({ sequenceId }),
  resetStepAndSequence: () => resetSequenceAndStepData(),
  resetSelectedContacts: () => resetSelectedTasks(),

  // Single Prospect Details Dispatch Props
  setSelectedProspectId: (id: number) => setSelectedProspectId(id),
  resetSelectedProspectId: () => resetSelectedProspectId(),
  resetSelectedProspectData: () => resetSelectedProspectData(),
  resetGetTasksState: () => resetGetTasksState(),
  getTaskerDataRequest: (params: GetTaskerParams) =>
    getTaskerDataRequest(params),
  getFieldsRequest: () => getFieldsRequest({}),
  getFailedTasksRequest: (params: { page?: number; limit?: number }) =>
    getFailedTasksRequest(params),
  retryLinkedInTasksRequest: (params: { taskIds: number[] }) =>
    retryLinkedInTasksRequest(params),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> &
  RouteComponentProps & {
    taskStatus: TaskStatusKey;
    updateLocalTaskStatusCounts?: (newCounts: any) => void;
  };

export default withRouter(connector(TasksContent));
